import { Link } from 'gatsby'
import React from 'react'
import logo from '../../assets/vectors/white.png'
import LogoStyle from './LogoStyle/LogoStyle'

const Logo = ({isTop, handleGoToTop}) => (
    <Link to='/'><LogoStyle isTop={isTop} src={logo} onClick={handleGoToTop} /></Link>
)

export default Logo